import { render, staticRenderFns } from "./H2.vue?vue&type=template&id=2168cda4&scoped=true&"
var script = {}
import style0 from "./H2.vue?vue&type=style&index=0&id=2168cda4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2168cda4",
  null
  
)

export default component.exports